"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestOfferRequestSchema = void 0;
/**
 *  The validation schema for a request.
 */
exports.RequestOfferRequestSchema = {
    $id: '#request-offer-request',
    type: 'object',
    additionalProperties: false,
    /**
     *  Default required properties,
     */
    required: [
        'client',
        'address',
        'terms_and_conditions',
        'privacy_statement',
        'preferred_installation_date',
        'service_products',
        'additional_products',
        'requested_installation',
        'spaces',
    ],
    /**
     *  The properties.
     */
    properties: {
        company: { type: ['string', 'object'] },
        requested_installation: { type: 'number', enum: [0, 1] },
        address: { type: 'object' },
        client: { type: 'object', $ref: '#request-client' },
        terms_and_conditions: { type: 'number' },
        privacy_statement: { type: 'number' },
        preferred_installation_date: { type: ['string', 'null'] },
        service_products: { type: 'array', items: { type: 'string' } },
        additional_products: { type: 'array', items: { type: 'object' } },
        remarks: { type: ['string', 'null'] },
        spaces: { type: 'array', items: { type: 'object', /** $ref: '#request-space' */ } },
    },
    /**
     *  Conditional validation.
     */
    allOf: [
        /**
         *  Lets it validate the address if the user requested installation.
         */
        {
            if: {
                required: ['requested_installation'],
                properties: {
                    requested_installation: {
                        const: 1,
                    },
                },
            },
            then: {
                required: [
                    'address',
                    'preferred_installation_date',
                ],
                properties: {
                    address: { $ref: '#request-address' },
                    preferred_installation_date: { type: 'string' },
                },
            },
        },
    ],
    /**
     *  Error messages.
     */
    errorMessage: {
        properties: {
            preferred_installation_date: '',
            terms_and_conditions: 'Je bent vergeten akkoord te gaan met onze algemene voorwaarden',
            privacy_statement: 'Je bent vergeten akkoord te gaan met onze privacyverklaring',
        },
    },
};
//# sourceMappingURL=offer-request.schema.js.map